
import { SET_CURRENT_USER, REMOVE_CURRENT_USER } from "./user.actiontypes"

const INITIAL_STATE = {
    currentUser: null
}

const userReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_USER:
            return {
                ...state,
                currentUser: action.payload
            }
        case REMOVE_CURRENT_USER:
            return {
                ...state,
                currentUser: null
            }
        default:
            return state;
    }
}

export default userReducer;
